import Vue from 'vue/dist/vue.esm';
import axios from 'common/axios';
import SpacesList from 'components/spaces/spaces_list.vue';

document.addEventListener('page:change', () => {
  new Vue({
    el: '#spaces',
    components: { SpacesList },
    data: {
      page: 1 ,
      spaces: [],
      errorMessage: ''
    },
    methods: {
      infiniteLoad($state) {
        axios.get(location.href, {
          params: {
            page: this.page
          },
        }).then(({ data }) => {
          if (data.spaces.length) {
            this.page += 1;
            this.spaces.push(...data.spaces);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      },
      toggleFollow: async function(space) {
        const params = {
          ajax_handler: 'handler_spaces_follow_or_unfollow',
          target_space_id: space.id
        };
        let succeeded = false;
        await axios.get('/mypage/ajax_spaces_follow_or_unfollow', { params: params }).then((response) => {
          succeeded = response.data.status == 'success';
        }).catch(() => {
          succeeded = false;
        });
        if (succeeded) {
          this.errorMessage = '';
          space.current_user_following = !space.current_user_following;
        } else {
          this.errorMessage = '通信に失敗しました。再読み込みを行います。';
          location.reload();
        }
      }
    },
    template: `
      <div>
        <spaces-list
          v-bind:spaces='spaces'
          :errorMessage ='errorMessage'
          @infinite-load='infiniteLoad'
          @toggle-follow='toggleFollow'
        >
        </spaces-list>
      </div>
    `
  });
});
